import { Inject, Injectable, Injector } from '@angular/core';
import {
  ProfissionalRequest,
  ProfissionalResponse,
} from '../../../models/profissional.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { DefinirMetaBody } from '../../../models/definicao-de-meta.models';

@Injectable({
  providedIn: 'root',
})
export class NewApiProfissionalService extends UtilsBaseApiService<NewApiProfissionalService> {

  private readonly DEFINICAO_META = 'definicaoMeta'
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('profissional', injector, environment.BASE_API_URL);
  }

  getProfissionais(request: ProfissionalRequest) {
    const queryString = this.getQueryString(request);
    return this.httpClient.get<ProfissionalResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}?${queryString}`
    );
  }

  definirMeta(codUsur: number, codFunc: number, valor: number, tempo: string | Date, alcan?: 'S' | 'N') {
    const body: DefinirMetaBody = {
      pCODVENDEDOR: codUsur,
      pCODFUNC: codFunc,
      pTEMPO: tempo,
      pVALOR: valor,
      pALCAN: alcan
    }

    return this.httpClient.post(`${this.BASE_URL}${this.CONTEXT}/${this.DEFINICAO_META}`, body, { responseType: 'text' })
  }
}